import { render, staticRenderFns } from "./HomeMessageBlock.vue?vue&type=template&id=e3e969c8&scoped=true&"
import script from "./HomeMessageBlock.vue?vue&type=script&lang=js&"
export * from "./HomeMessageBlock.vue?vue&type=script&lang=js&"
import style0 from "./HomeMessageBlock.vue?vue&type=style&index=0&id=e3e969c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3e969c8",
  null
  
)

export default component.exports